import { Monster } from "@/data/interfaces.ts";
import { useSignal } from "@preact/signals";
import { MonsterCard } from "@/islands/MonsterCard.tsx"; // Corrected import path

interface HeaderProps {
  monsters: Monster[];
}

export default function MonsterLayout({ monsters }: HeaderProps) {
  const monsterSignal = useSignal<Monster[]>(monsters);

  return (
    <>
      {monsterSignal.value.map((m) => (
        <MonsterCard
          monster={m}
          isFake={true}
        />
      ))}
    </>
  );
}
